"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Input_st_css_1 = require("./Input.st.css");
var classnames_1 = require("classnames");
var filter_data_props_1 = require("../../utils/filter-data-props");
var Input = /** @class */ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focus: false,
        };
        _this._extractRef = function (ref) {
            var inputRef = _this.props.inputRef;
            _this.input = ref;
            if (inputRef) {
                inputRef(ref);
            }
        };
        _this.handleFocus = function (event) {
            _this.setState({ focus: true });
            _this.props.onFocus(event);
        };
        _this.handleBlur = function (event) {
            _this.setState({ focus: false });
            _this.props.onBlur(event);
        };
        return _this;
    }
    Input.prototype.render = function () {
        var focus = this.state.focus;
        var _a = this.props, error = _a.error, disabled = _a.disabled, prefix = _a.prefix, suffix = _a.suffix, inlineStyle = _a.style, id = _a.id;
        var _b = this.props, errorProp = _b.error, styleProp = _b.style, prefixProps = _b.prefix, suffixProp = _b.suffix, inputClassName = _b.inputClassName, className = _b.className, inputRef = _b.inputRef, allOtherProps = tslib_1.__rest(_b, ["error", "style", "prefix", "suffix", "inputClassName", "className", "inputRef"]);
        return (React.createElement("div", tslib_1.__assign({ className: Input_st_css_1.st(Input_st_css_1.classes.root, { disabled: disabled, error: !!error && !disabled, focus: focus }, className), style: inlineStyle }, filter_data_props_1.filterDataProps(this.props)),
            prefix,
            React.createElement("input", tslib_1.__assign({ id: id }, allOtherProps, { ref: this._extractRef, className: classnames_1.default(Input_st_css_1.classes.nativeInput, inputClassName), onBlur: this.handleBlur, onFocus: this.handleFocus })),
            suffix));
    };
    Input.prototype.focus = function () {
        this.input.focus();
    };
    Input.prototype.blur = function () {
        this.input.blur();
    };
    Input.prototype.select = function () {
        this.input.select();
    };
    Input.prototype.getSelectionStart = function () {
        return this.input.selectionStart;
    };
    Input.prototype.getSelectionEnd = function () {
        return this.input.selectionEnd;
    };
    Input.prototype.setSelectionRange = function (start, end) {
        this.input.setSelectionRange(start, end);
    };
    Input.displayName = 'Input';
    Input.defaultProps = {
        type: 'text',
        onFocus: function () { return null; },
        onBlur: function () { return null; },
        onChange: function () { return null; },
    };
    return Input;
}(React.Component));
exports.Input = Input;
//# sourceMappingURL=Input.js.map